<template>
  <v-layout>
    <div id="map"></div>
    <v-btn
      id="btn"
      color="primary"
      class="mx-auto"
      height="50"
      width="250"
      :disabled="btnCoordendas"
      @click="enviarUbicacion()"
      >ENVIAR MI UBICACION
      <v-icon right dark> fas fa-location-arrow </v-icon>
    </v-btn>
  </v-layout>
</template>

<script>
import mapboxgl from "mapbox-gl";
import { dbCoordenadas } from "../main";
export default {
  data() {
    return {
      map: "",
      accessToken:
        "pk.eyJ1Ijoiam9obmxpbmFyZXMiLCJhIjoiY2tjcWk2eDZrMTU2bjJyczVyMWF0ejg3NiJ9.848u9JaZDYfKTRPBzFvDwA",
      marker: [
        {
          name: "Mi posición",
          position: [0, 0],
        },
      ],
      latitude: 0,
      longitude: 0,
      btnCoordendas: false,
      numeroAsistencia: "",
    };
  },
  mounted() {
    mapboxgl.accessToken = this.accessToken;
    this.map = new mapboxgl.Map({
      container: "map",
      style: "mapbox://styles/mapbox/streets-v11",
      center: [-88.89653, 13.794185],
      zoom: 7,
    });
    this.map.addControl(new mapboxgl.FullscreenControl());
    this.map.addControl(
      new mapboxgl.GeolocateControl({
        positionOptions: {
          enableHighAccuracy: true,
        },
        trackUserLocation: true,
      })
    );
    this.map.addControl(new mapboxgl.NavigationControl());
    navigator.geolocation.getCurrentPosition(this.permisosUbicacion);
  },
  created() {
    this.obtenerURL();
  },
  methods: {
    obtenerURL() {
      this.numeroAsistencia = this.$route.params.id;
    },
    permisosUbicacion(position) {
      this.latitude = position.coords.latitude;
      this.longitude = position.coords.longitude;
      this.map.flyTo({
        center: [this.longitude, this.latitude],
        zoom: 14,
        bearing: 0,
        speed: 1.5,
        curve: 1,
        easing: function (t) {
          return t;
        },
        essential: true,
      });
      new mapboxgl.Marker({ color: "blue" })
        .setLngLat([this.longitude, this.latitude])
        .setPopup(
          new mapboxgl.Popup({ offset: 25 }).setHTML(
            "<strong>" +
              this.marker[0].name +
              ": Latitude: " +
              this.latitude +
              " Longitud: " +
              this.longitude +
              "</strong>"
          )
        )
        .addTo(this.map);
    },
    enviarUbicacion() {
      let me = this;
      if (
        me.latitude != null &&
        me.latitude != "" &&
        me.latitude != 0 &&
        me.longitude != null &&
        me.longitude != "" &&
        me.longitude != 0
      ) {
        me.btnCoordendas = false;
        var today = new Date();
        var fechaActual =
          today.getFullYear() +
          "-" +
          (today.getMonth() + 1) +
          "-" +
          today.getDate() +
          " " +
          new Date().getHours() +
          ":" +
          new Date().getMinutes() +
          ":" +
          new Date().getSeconds();
        dbCoordenadas
          .child(this.numeroAsistencia)
          .set({ latitude: me.latitude, longitude: me.longitude })
          .then(function () {
            me.$swal.fire({
              position: "top-center",
              icon: "success",
              title: "Su ubicación fue enviada correctamente",
              showConfirmButton: true,
            });
          })
          .catch(function (error) {
            me.$swal.fire({
              position: "top-center",
              icon: "error",
              title: "Hubo algún error y no se pudo enviar su ubicación",
              showConfirmButton: true,
            });
          });
      } else {
        me.$swal.fire({
          position: "top-center",
          title: "No se pude obtener su ubicación",
          text: "Verifique que los permisos de ubicación este habilitado en el navegador y recargue la pagina",
          imageUrl: require('@/assets/img_permisos.png'),
          imageHeight: 500,
          showConfirmButton: true,
        });
      }
    },
  },
};
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
}
#map {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
}
#btn {
  position: relative;
  top: 90%;
}
</style>